export const GetPlanJson = [
    {
        systemLicenseId: 'EB9C09B2-02E1-4A0D-B7C6-0764F772A821',
        packageName: 'Premium (50 Users)',
        packageCode: 'TH6_50_STANDARD',
        numberOfUsers: 50,
        version: 6,
        productCode: 4653365,
        isTrakLive: 0,
        isCurrentVersion: 1,
        sortOrder: 2,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: 'F720E9EA-0BEA-47B3-9763-1A0112A10B41',
        packageName: 'Enterprise',
        packageCode: 'TH6_99999',
        numberOfUsers: 999,
        version: 6,
        productCode: 46286290,
        isTrakLive: 0,
        isCurrentVersion: 1,
        sortOrder: 4,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: '408F69FC-3D8F-4398-9C04-7B8CEAD0D485',
        packageName: 'Standard Per User',
        packageCode: 'TH6_STANDARD',
        numberOfUsers: 1,
        version: 6,
        productCode: 4628470,
        isTrakLive: 0,
        isCurrentVersion: 1,
        sortOrder: 1,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: 'EABBBDCF-496B-4A4B-A64B-C14CBCA41CE8',
        packageName: 'Premium Plus (200 Users)',
        packageCode: 'TH6_PREMIUMPLUS_TIMESHEET_EXPENSE_TIMEOFF_QB_200',
        numberOfUsers: 200,
        version: 6,
        productCode: null,
        isTrakLive: 0,
        isCurrentVersion: 1,
        sortOrder: 3,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: '98BDCB7E-8146-409B-82B6-ECC8EE5B7A05',
        packageName: 'Standard (Per User)',
        packageCode: 'TH5_STANDARD',
        numberOfUsers: 1,
        version: 5,
        productCode: 4611552,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 1,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: 'E904DF52-B2CF-4BD2-AF97-2EA3E93AB9EC',
        packageName: 'Enterprise',
        packageCode: 'TH4_99999',
        numberOfUsers: 999,
        version: 5,
        productCode: 4552884,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 2,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: 'A9BFE3BF-C060-4A06-BB14-A66762686712',
        packageName: 'Standard (Per User)',
        packageCode: 'TH4_STANDARD',
        numberOfUsers: 1,
        version: 4,
        productCode: 4552303,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 1,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: '26C0C5ED-99B8-4521-8E3F-B7EF0DE1AE1E',
        packageName: 'Enterprise',
        packageCode: 'TH4_99999',
        numberOfUsers: 999,
        version: 4,
        productCode: 4552884,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 2,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: '7B8A7B4F-35A8-45D0-9EC6-8E903EA0FEB8',
        packageName: 'Enterprise',
        packageCode: 'TH_99999',
        numberOfUsers: 999,
        version: 3,
        productCode: 4026854,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 6,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: '9E36283B-3A5A-4C70-BF6B-37ABBFBC666C',
        packageName: 'Standard Plus (50 Users)',
        packageCode: 'TH_50',
        numberOfUsers: 50,
        version: 3,
        productCode: 4026916,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 3,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: '5F7D95D0-BA39-4461-B9A9-2BCB7421D5C4',
        packageName: 'Basic (10 Users)',
        packageCode: 'TH_10',
        numberOfUsers: 10,
        version: 3,
        productCode: 4026900,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 1,
        description: "A solid starting point for small teams. Includes essential features to manage time, tasks, and users with ease — optimized for productivity and collaboration."
    },
    {
        systemLicenseId: '666B1B69-2BA7-4330-879C-07D4AB7813D5',
        packageName: 'TimeLive Standard (25 Users)',
        packageCode: 'TH_25',
        numberOfUsers: 25,
        version: 3,
        productCode: 4026884,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 2,
        description: "Built for growing teams that need more flexibility and control. Offers advanced tools for time tracking, user management, and performance insights."
    },
    {
        systemLicenseId: 'BA8EA6D6-4370-45BF-8171-EFF37EB3C0A7',
        packageName: 'Premium (75 Users)',
        packageCode: 'TH_75',
        numberOfUsers: 75,
        version: 3,
        productCode: 4026876,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 4,
        description: "Unlock powerful features with every plan. Whether you're just starting or managing a large team, we’ve got you covered"
    },
    {
        systemLicenseId: 'E9971952-AA26-4CD1-BF14-D1DE5211D0BD',
        packageName: 'Premium Plus (100 Users)',
        packageCode: 'TH_100',
        numberOfUsers: 100,
        version: 3,
        productCode: 4026863,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 5,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: '2886F09F-0C32-422F-BEA4-DF94D2256B2B',
        packageName: 'Standard Plus (50 Users)',
        packageCode: 'TH_50',
        numberOfUsers: 50,
        version: 2,
        productCode: 2789980,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 3,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: '7F162EB3-3A9B-4C0A-A9F5-DFE44C37795A',
        packageName: 'Basic (10 Users)',
        packageCode: 'TH_10',
        numberOfUsers: 10,
        version: 2,
        productCode: 2789935,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 1,
        description: "A solid starting point for small teams. Includes essential features to manage time, tasks, and users with ease — optimized for productivity and collaboration."
    },
    {
        systemLicenseId: '787F5C5E-06F4-49D5-A321-408D73094850',
        packageName: 'Premium (75 Users)',
        packageCode: 'TH_75',
        numberOfUsers: 75,
        version: 2,
        productCode: 2789992,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 4,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: '196B1120-6CDD-4B6C-A8C3-5B08950C541E',
        packageName: 'Premium Plus (100 Users)',
        packageCode: 'TH_100_150',
        numberOfUsers: 100,
        version: 2,
        productCode: 2790000,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 5,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: '29074FE9-E72D-41B4-941F-67E367FFF1C4',
        packageName: 'Enterprise',
        packageCode: 'TH_99999',
        numberOfUsers: 999,
        version: 2,
        productCode: 2790003,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 6,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: '9390B084-D50F-4AB4-A2C8-B77376064DB4',
        packageName: 'Premium Plus (100 Users)',
        packageCode: 'TH_100',
        numberOfUsers: 100,
        version: 2,
        productCode: 2790000,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 5,
        description: "Tailored for large teams seeking robust time tracking and project management. Includes comprehensive features and integrations to streamline operations."
    },
    {
        systemLicenseId: '17974732-8462-4E3A-8CB4-AE032F01236F',
        packageName: 'TimeLive Standard (25 Users)',
        packageCode: 'TH_25',
        numberOfUsers: 25,
        version: 2,
        productCode: 2789939,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 2,
        description: "Built for growing teams that need more flexibility and control. Offers advanced tools for time tracking, user management, and performance insights."
    },
    {
        systemLicenseId: '71FFA424-8F25-4DCA-BB54-8855FCCECA61',
        packageName: 'Basic (10 Users)',
        packageCode: 'TLHB',
        numberOfUsers: 10,
        version: 1,
        productCode: 1808893,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 1,
        description: "A solid starting point for small teams. Includes essential features to manage time, tasks, and users with ease — optimized for productivity and collaboration."
    },
    {
        systemLicenseId: '5D582B86-6E92-47AD-ACA4-BD5731FEB391',
        packageName: 'TimeLive Standard (25 Users)',
        packageCode: 'TLHS',
        numberOfUsers: 25,
        version: 1,
        productCode: 1808895,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 2,
        description: "Built for growing teams that need more flexibility and control. Offers advanced tools for time tracking, user management, and performance insights."
    },
    {
        systemLicenseId: '3BFEC2B1-CEEE-41CC-A249-14B9AFABFDC7',
        packageName: 'Standard (Per User)',
        packageCode: 'TLBT_STANDARD',
        numberOfUsers: 1,
        version: 1,
        productCode: 4593725,
        isTrakLive: 1,
        isCurrentVersion: 1,
        sortOrder: 1,
        description: "A pay-as-you-grow model for organizations that need scalable user management. Perfect for dynamic teams with changing size and requirements."
    },
    {
        systemLicenseId: 'FC1A130E-C6E7-4EB8-9369-C8A59152EC20',
        packageName: 'Enterprise',
        packageCode: 'TLHE',
        numberOfUsers: 999,
        version: 1,
        productCode: 1808894,
        isTrakLive: 0,
        isCurrentVersion: 0,
        sortOrder: 3,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: 'FEA6F3E1-D56A-4D89-ACEF-CB6EE944C8E7',
        packageName: 'Enterprise',
        packageCode: 'TLBT_99999',
        numberOfUsers: 999,
        version: 1,
        productCode: 4593817,
        isTrakLive: 1,
        isCurrentVersion: 1,
        sortOrder: 2,
        description: "The ultimate solution for large organizations. Includes custom configurations, priority support, and enterprise-level security to meet complex business needs."
    },
    {
        systemLicenseId: '17E3DEAA-2620-4FF7-9B33-69C1406FA313',
        packageName: 'Lite (Free)',
        packageCode: 'Lite',
        numberOfUsers: 999,
        version: null,
        productCode: null,
        isTrakLive: 0,
        isCurrentVersion: 1,
        sortOrder: 0,
        description: "Explore all the core features of the application with a free trial — no payment required. A great way to evaluate how our solution fits your team before committing."
    },
    {
        systemLicenseId: 'D80D2A17-0D8C-46B4-B958-B28B960D1373',
        packageName: 'Lite (Free)',
        packageCode: 'Lite',
        numberOfUsers: 999,
        version: null,
        productCode: null,
        isTrakLive: 1,
        isCurrentVersion: 1,
        sortOrder: 0,
        description: "Explore all the core features of the application with a free trial — no payment required. A great way to evaluate how our solution fits your team before committing."
    },
]